import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📆", key: "weekly" },
  { emoji: "🗓️", key: "monthly" },
  { emoji: "🔔", key: "whenSomethingChanges" },
  { emoji: "🧊", key: "rarely" },
]

export default function CarsUpdateFrequencyPage() {
  return (
    <RadioCardListPage translationKey="carsUpdateFrequency" options={OPTIONS} />
  )
}
